import { DEFAULT_MAPBOX_TOKEN, MAPBOX_GL_CSS, MAPBOX_GL_JS } from "./mapbox-config.js";

let mapboxLoadPromise = null;

export function mapboxToken() {
  const params = new URLSearchParams(window.location.search);
  const queryToken = params.get("mapboxToken");
  if (queryToken) {
    localStorage.setItem("community-report-mapbox-token", queryToken);
    return queryToken;
  }
  return localStorage.getItem("community-report-mapbox-token") || DEFAULT_MAPBOX_TOKEN;
}

export function loadMapboxGl() {
  if (window.mapboxgl) return Promise.resolve();
  if (mapboxLoadPromise) return mapboxLoadPromise;

  mapboxLoadPromise = new Promise((resolve, reject) => {
    if (!document.querySelector(`link[href="${MAPBOX_GL_CSS}"]`)) {
      const stylesheet = document.createElement("link");
      stylesheet.rel = "stylesheet";
      stylesheet.href = MAPBOX_GL_CSS;
      document.head.append(stylesheet);
    }

    const script = document.createElement("script");
    script.src = MAPBOX_GL_JS;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("CDN script unavailable"));
    document.head.append(script);
  });

  return mapboxLoadPromise;
}

export function mapFallbackMarkup(title, message) {
  return `
    <div class="map-fallback">
      <strong>${title}</strong>
      <span>${message}</span>
    </div>
  `;
}
